import React, { FC, useCallback, useContext } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import set from 'lodash/set';
import styled from 'styled-components';

import FieldContainer from './FieldContainer';
import FormContext from 'src/presentation/contexts/FormContext';
import AdRadioGroup from '@ad-scripts/presentation/components/common/radio_group';

type RadioProps = {
  attr: string;
  className?: string;
  'data-aid'?: string;
  disabled?: boolean;
  description?: string | JSX.Element;
  label?: string;
  onChange?: Function;
  options: { label?: string; value: number | string | boolean; description?: string }[];
  value?: string | number;
};

const RadioGroup: FC<RadioProps> = ({
  attr,
  className,
  description,
  'data-aid': dataAid,
  disabled,
  label,
  onChange,
  options,
  value,
}) => {
  const { errors, workingState, updateState } = useContext(FormContext);

  const error = find(errors, error => error.attr === attr);
  const onRadioChange = useCallback(
    ev => {
      if (onChange) {
        onChange(ev);
      } else {
        let value = ev.target.value;

        value = ['true', 'false'].includes(value) ? value === 'true' : value;

        updateState(set({}, attr, value));
      }
    },
    [attr, onChange, updateState]
  );

  const workingVal = value ? value : get(workingState, attr);

  return (
    <RadioContainer
      data-aid={dataAid}
      description={description}
      error={error ? error.detail : null}
      label={label}
      role="radiogroup"
      control={
        <AdRadioGroup
          className={className}
          data-aid={dataAid}
          disabled={disabled}
          options={options}
          onChange={onRadioChange}
          value={workingVal}
        />
      }
    />
  );
};

const RadioContainer = styled(FieldContainer)`
  flex-grow: 0;
`;

export default RadioGroup;
